import DateOfBirthPicker from './date-of-birth-picker';
import './date-of-birth-picker.scss';

export default DateOfBirthPicker;
